var __jsx = React.createElement;
import React from "react";
import CopyableField from "@/pages/checkout/dhamen/components/common/CopyableField";
import { useTranslation } from "@i18n";
import ContactModal from "@/pages/checkout/dhamen/components/common/ContactModal";
import useBoolean from "@hooks/useBoolean";
import { useDhamenContext } from "@/common/Contexts/DhamenContextProvider";
import ReusableBtn from "@/pages/checkout/bnpl/common/components/ReusableBtn";
import SAR from "@componentsShared/SAR/SAR";
var ActiveOfferScreen = function ActiveOfferScreen() {
  var _data$order, _data$order$post_deta, _data$order2, _data$order2$pricing, _data$financing_detai, _data$financing_detai2, _data$financing_detai3, _data$financing_detai4, _data$financing_detai5, _state$orderInfo, _state$orderInfo$fina, _state$orderInfo3;
  var _useTranslation = useTranslation(),
    t = _useTranslation.t,
    tShort = _useTranslation.tShort;
  var _useDhamenContext = useDhamenContext(),
    state = _useDhamenContext.state;
  var contactModal = useBoolean();
  var data = state.orderInfo;
  var carTitle = (data === null || data === void 0 ? void 0 : (_data$order = data.order) === null || _data$order === void 0 ? void 0 : (_data$order$post_deta = _data$order.post_details) === null || _data$order$post_deta === void 0 ? void 0 : _data$order$post_deta.title_ar) || "";
  var carPrice = (data === null || data === void 0 ? void 0 : (_data$order2 = data.order) === null || _data$order2 === void 0 ? void 0 : (_data$order2$pricing = _data$order2.pricing) === null || _data$order2$pricing === void 0 ? void 0 : _data$order2$pricing.total_price) || "";
  var financingAmount = (data === null || data === void 0 ? void 0 : (_data$financing_detai = data.financing_details) === null || _data$financing_detai === void 0 ? void 0 : _data$financing_detai.financing_amount) || "";
  var adminFees = (data === null || data === void 0 ? void 0 : (_data$financing_detai2 = data.financing_details) === null || _data$financing_detai2 === void 0 ? void 0 : _data$financing_detai2.admin_fees) || "";
  var apr = (data === null || data === void 0 ? void 0 : (_data$financing_detai3 = data.financing_details) === null || _data$financing_detai3 === void 0 ? void 0 : _data$financing_detai3.apr) || "";
  var contractTermYears = (data === null || data === void 0 ? void 0 : (_data$financing_detai4 = data.financing_details) === null || _data$financing_detai4 === void 0 ? void 0 : _data$financing_detai4.contract_term_years) || "";
  var monthlyInstallment = (data === null || data === void 0 ? void 0 : (_data$financing_detai5 = data.financing_details) === null || _data$financing_detai5 === void 0 ? void 0 : _data$financing_detai5.monthly_installment) || "";
  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: "md:min-h-screen h-full md:pt-0 pt-4 bg-gray-50 flex items-center justify-center p-4"
  }, /*#__PURE__*/React.createElement("div", {
    className: "w-full max-w-[560px] bg-white rounded-lg shadow-sm"
  }, /*#__PURE__*/React.createElement("div", {
    className: "p-6"
  }, /*#__PURE__*/React.createElement("h2", {
    className: "md:text-[30px] text-2xl font-bold text-[#154F9C] text-center my-2 md:my-4"
  }, tShort("dhamen/active_offer_header")), /*#__PURE__*/React.createElement("p", {
    className: "py-6 leading-6 text-[16px] md:text-[20px] text-[#6C7A8D] text-center px-4 md:px-10"
  }, tShort("dhamen/active_offer_redirect_text"), " "), /*#__PURE__*/React.createElement("div", {
    className: "mb-6"
  }, /*#__PURE__*/React.createElement(CopyableField, {
    label: tShort("dhamen/reference_number"),
    value: (_state$orderInfo = state.orderInfo) === null || _state$orderInfo === void 0 ? void 0 : (_state$orderInfo$fina = _state$orderInfo.financing_details) === null || _state$orderInfo$fina === void 0 ? void 0 : _state$orderInfo$fina.quote_no,
    onCopy: function onCopy() {}
  }), /*#__PURE__*/React.createElement("div", {
    className: "border  border-[#d6dfe9] border-[0px_0px_1px] border-solid rounded-lg"
  }, /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] flex justify-between items-center py-3 px-2 border-b border-[#d6dfe9] border-[0px_0px_1px] border-solid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] font-bold"
  }, tShort("dhamen/request_financing_on")), /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold md:text-lg"
  }, carTitle)), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] flex justify-between items-center py-3 px-2 border-b border-[#d6dfe9] border-[0px_0px_1px] border-solid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] font-bold"
  }, tShort("dhamen/car_price")), /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold md:text-lg"
  }, carPrice, " ", /*#__PURE__*/React.createElement(SAR, null))), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] flex justify-between items-center py-3 px-2 border-b border-[#d6dfe9] border-[0px_0px_1px] border-solid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] font-bold"
  }, tShort("dhamen/financing_amount")), financingAmount && /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold md:text-lg"
  }, Number(financingAmount).toLocaleString(), " ", /*#__PURE__*/React.createElement(SAR, null))), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] flex justify-between items-center py-3 px-2 border-b border-[#d6dfe9] border-[0px_0px_1px] border-solid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] font-bold"
  }, tShort("dhamen/admin_fees_vat")), adminFees && /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold md:text-lg"
  }, Number(adminFees).toLocaleString(), " ", /*#__PURE__*/React.createElement(SAR, null))), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] flex justify-between items-center py-3 px-2 border-b border-[#d6dfe9] border-[0px_0px_1px] border-solid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] font-bold"
  }, tShort("dhamen/apr")), /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold "
  }, apr ? "".concat(apr, "%") : "")), /*#__PURE__*/React.createElement("div", {
    className: "text-[16px] flex justify-between items-center py-3 px-2 border-b border-[#d6dfe9] border-[0px_0px_1px] border-solid"
  }, /*#__PURE__*/React.createElement("span", {
    className: "text-[#484848] font-bold "
  }, tShort("dhamen/contract_duration")), /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold "
  }, contractTermYears ? "".concat(contractTermYears, " ").concat(tShort("dhamen/years")) : "")), /*#__PURE__*/React.createElement("div", {
    className: "bg-[#F0F5FB] text-[16px] flex justify-between items-center py-3 px-2"
  }, /*#__PURE__*/React.createElement("span", {
    className: "font-bold text-[#154F9C]"
  }, tShort("dhamen/monthly_installment_label")), monthlyInstallment && /*#__PURE__*/React.createElement("span", {
    className: "text-[#154F9C] font-bold md:text-lg"
  }, Number(monthlyInstallment).toLocaleString(), " ", /*#__PURE__*/React.createElement(SAR, null))))), /*#__PURE__*/React.createElement("div", {
    className: "space-y-3"
  }, /*#__PURE__*/React.createElement(ReusableBtn, {
    label: tShort("dhamen/go_to_alj_platform"),
    onClick: function onClick() {
      var _state$orderInfo2, _state$orderInfo2$fin;
      return window.open(state === null || state === void 0 ? void 0 : (_state$orderInfo2 = state.orderInfo) === null || _state$orderInfo2 === void 0 ? void 0 : (_state$orderInfo2$fin = _state$orderInfo2.financing_details) === null || _state$orderInfo2$fin === void 0 ? void 0 : _state$orderInfo2$fin.url, "_blank");
    },
    variant: "fill"
  }), /*#__PURE__*/React.createElement(ReusableBtn, {
    label: tShort("dhamen/contact_request_manager"),
    onClick: contactModal.setTrue,
    variant: "outline"
  }))))), /*#__PURE__*/React.createElement(ContactModal, {
    open: contactModal.value,
    onClose: contactModal.setFalse,
    toggle: contactModal.toggle,
    title: tShort("dhamen/contact_us_via"),
    phoneNumber: state === null || state === void 0 ? void 0 : (_state$orderInfo3 = state.orderInfo) === null || _state$orderInfo3 === void 0 ? void 0 : _state$orderInfo3.order.sales_user.phone_number
  }));
};
export default ActiveOfferScreen;